import { useEffectWithController } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import UserContext from '~/context/common/UserContext';
import AvailabilityContext from '~/context/home/AvailabilityAndPriceContext';
import { useGetIsReturnUser } from '~/context/home/GlobalContext';
import MegaEventContext from '~/context/home/MegaEventContext';
import SuggestedForYouContext from '~/context/home/SuggestedForYouContext';
import { fetchSuggestedVehicles } from '~/services/home';
import toAvailabilityPayloads from '~/utilities/home/requests/toAvailabilityPayloads';
import { generateErrorLogger } from '~/utilities/loggers';

export default function useGetSuggestedForYou() {
  const {
    suggestedVehicles: { setData, setLoading, setError },
    fetchSuggestedForYouTrigger
  } = useContext(SuggestedForYouContext);
  const {
    suggestedVehicleAvailability: {
      setData: setAvailabilityData,
      setError: setAvailabilityError
    }
  } = useContext(AvailabilityContext);
  const { setSuggestedVehicles: setMegaEventSuggestedVehicles } =
    useContext(MegaEventContext);
  const {
    location: {
      data: { zip = '' }
    },
    userState: { isLoaded }
  } = useContext(UserContext);
  const isReturningUser = useGetIsReturnUser();

  useEffectWithController(
    controller => {
      if (!isLoaded || !zip || !isReturningUser) return;

      setLoading();

      fetchSuggestedVehicles({ zipCode: zip }, controller)
        .then(vehicles => {
          setData(vehicles);
          setMegaEventSuggestedVehicles(vehicles);

          setAvailabilityData(toAvailabilityPayloads(vehicles));
        })
        .catch(
          generateErrorLogger(
            'Suggested For You',
            {},
            {
              callback: err => {
                setError(err);
                setAvailabilityError(err);
              },
              controller
            }
          )
        );
    },
    [
      fetchSuggestedForYouTrigger,
      isLoaded,
      isReturningUser,
      setAvailabilityData,
      setAvailabilityError,
      setData,
      setError,
      setLoading,
      setMegaEventSuggestedVehicles,
      zip
    ]
  );
}
